// NOTE: THIS IS A READ-ONLY FILE THAT EMITS DICTIONARIES BASED ON EXISTING DATA

function generateDictionary(listItems, key) {
    if (!listItems || listItems.length == 0) return {};

    return listItems.reduce((accumulator, item) => {
        return {
            ...accumulator,
            [item[key]]: item
        };
    }, {});
}

const getters = {
    accountUsersDictionary(state, getters, rootState, rootGetters) {
        return generateDictionary(rootState.TeamDirectory.appUsers, "UserId");
    }
};

export default {
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/Dictionary.js